import {
  FETCH_EXCHANGE_STATUS,
  FETCH_EXCHANGE_STATUS_ERROR,
  FETCH_EXCHANGE_STATUS_SUCCESS,
  ExchangeStatusActions,
} from '../../../types/actions/Exchanges/ExchangeStatus.actions';
import {IExchangeStatus} from '../../../types/models/ExchangeStatus';

export interface ExchangeStatusState {
  data: {
    [name: string]: IExchangeStatus;
  };
  isLoading: boolean;
}

const initialState: ExchangeStatusState = {
  isLoading: false,
  data: {},
};

export default (
  state = initialState,
  action: ExchangeStatusActions,
): ExchangeStatusState => {
  switch (action.type) {
    case FETCH_EXCHANGE_STATUS: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case FETCH_EXCHANGE_STATUS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          [action.payload.slug]: action.payload,
        },
      };
    }
    case FETCH_EXCHANGE_STATUS_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }
    default:
      return state;
  }
};
